import { render, staticRenderFns } from "./form-reset-password.vue?vue&type=template&id=1ca9527e&scoped=true&"
import script from "./form-reset-password.ts?vue&type=script&lang=ts&"
export * from "./form-reset-password.ts?vue&type=script&lang=ts&"
import style0 from "./form-reset-password.scss?vue&type=style&index=0&id=1ca9527e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca9527e",
  null
  
)

export default component.exports